import type React from 'react';

import { Link } from '@change-corgi/design-system-legacy/components/actions';

type Props = {
	id: string;
	email: string | null | undefined;
	emailHref: string;
	trackEmailDmClick: (id: string) => void;
};

export const EmailDm: React.FC<Props> = ({ id, email, emailHref, trackEmailDmClick }) => {
	return email ? (
		<Link
			data-testid="email-dm"
			data-qa="email-dm"
			onClick={() => trackEmailDmClick(id)}
			to={emailHref}
			target="_blank"
		>
			Send email
		</Link>
	) : null;
};
